module.exports = new __parcel__URL__("luca-company.ebbca258.webp").toString();